import * as ReactDOM from 'react-dom';

import HotelsSearchTop from '../src/StayPackage/HotelsSearchTop';
import HotelsSearch from '../src/StayPackage/HotelsSearch';
import HotelPlansSearch from '../src/StayPackage/HotelPlansSearch';
import FormDate from '../src/Form/FormDate';

const renderHotelsSearchTop = () => {
  const element = document.getElementById('hotels-search-top');
  if (element) {
    const featuredAreaCodes = JSON.parse(element.getAttribute('data-featured-area-codes'));
    const otherAreaCodes = JSON.parse(element.getAttribute('data-other-area-codes'));

    ReactDOM.render(<HotelsSearchTop featuredAreaCodes={featuredAreaCodes} otherAreaCodes={otherAreaCodes} />, element);
  }
};

const renderHotelSearch = () => {
  const element = document.getElementById('hotels-search');

  if (element) {
    const featuredAreaCodes = JSON.parse(element.getAttribute('data-featured-area-codes'));
    const otherAreaCodes = JSON.parse(element.getAttribute('data-other-area-codes'));

    ReactDOM.render(<HotelsSearch featuredAreaCodes={featuredAreaCodes} otherAreaCodes={otherAreaCodes} />, element);
  }
};

const renderHotelPlansSearch = () => {
  const element = document.getElementById('hotel-plans-search');

  if (element) {
    const yadoId = element.getAttribute('data-yado-id');
    const hotelName = element.getAttribute('data-hotel-name');
    const standardCheckinTime = element.getAttribute('data-standard-checkin-time');
    const standardCheckoutTime = element.getAttribute('data-standard-checkout-time');
    const icons = JSON.parse(element.getAttribute('data-icons') || '{}');
    const reservableFrom = element.getAttribute('data-reservable-from');
    const reservableTo = element.getAttribute('data-reservable-to');
    const minimumStayDays = Number(element.getAttribute('data-minimum-stay-days'));
    const minimumClosingDays = Number(element.getAttribute('data-min-closing-days'));
    const nearestResortCode = element.getAttribute('data-nearest-resort-code');

    const hotel = {
      name: hotelName,
      standardCheckinTime: standardCheckinTime,
      standardCheckoutTime: standardCheckoutTime
    };

    ReactDOM.render(
      <HotelPlansSearch
        yadoId={yadoId}
        hotel={hotel}
        icons={icons}
        reservableFrom={reservableFrom}
        reservableTo={reservableTo}
        minimumStayDays={minimumStayDays}
        minimumClosingDays={minimumClosingDays}
        nearestResortCode={nearestResortCode}
      />,
      element);
  }
};

const renderScheduledDateForm = () => {
  const dom = document.getElementById('date-picker');
  const validDateFrom = new Date(dom?.getAttribute('data-valid-date-from') || '');
  validDateFrom.setHours(0)
  const validDateTo = new Date(dom?.getAttribute('data-valid-date-to') || '');
  const today = new Date();
  const dateDuration = dom?.getAttribute('data-date-duration') || 1;
  const selectableDateFrom = today > validDateFrom ? today : validDateFrom;

  if (dom) {
    ReactDOM.render(
      <FormDate
        formName='order_group[orders_attributes][0][scheduled_date]'
        minDate={selectableDateFrom}
        maxDate={validDateTo}
        dateDuration={Number(dateDuration)}
        isRangeSelect={false}
      />, dom as HTMLElement
    );
  }
}

document.addEventListener('turbolinks:load', () => {
  renderHotelsSearchTop();
  renderHotelSearch();
  renderHotelPlansSearch();
  renderScheduledDateForm();
});
